define('shared/initializer/form/newHouseAdapters/util/getReferredPayload',[
    '$',
    'shared/lib/RSVP',
    'shared/util/dispatchers/DataDispatcher',
    'shared/util/queryPersistence',
    './ValueCollectorForDataDispatcher'
],
function ( 
    $,
    RSVP,
    DataDispatcher,
    queryPersistence,
    ValueCollectorForDataDispatcher
) {
    'use strict';

    return function() {
        var payload = {};
        var collector = new ValueCollectorForDataDispatcher(payload);
        
        return RSVP.resolve()
            .then(function(){
                return new DataDispatcher($(document.documentElement))
                    .dispatch({
                        items:{
                            'by': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.referredby, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            },
                            'from': {
                                sources: [{type: 'queryPersistence', key: queryPersistence.CONSTANT.referredfrom, allowUndefined: true}],
                                targets: [{publish: collector.collect}]
                            }
                        },
                        timeout: 1000 * 60 * 60
                    });
            })
            .then(function(){
                return payload;
            });
    };
});
